import { Chip } from "@mui/material";
import { SCRAPER_STATUS_CHIP_COLOR } from "@/constants/status";

interface ScraperStatusChipProps {
  status: string;
  label: string;
}

export function ScraperStatusChip({ status, label }: ScraperStatusChipProps) {
  return (
    <Chip
      label={label}
      size="small"
      color={SCRAPER_STATUS_CHIP_COLOR[status] ?? "default"}
    />
  );
}
